import styles from "./PopUpHeader.module.css"

function PopUpHeader({ headerText, className, ...props }) {
    return (
        <h1 className={[styles.header, className].filter(e => !!e).join(' ')} {...props}>
            {headerText}
        </h1>
    )
}

export default PopUpHeader;